import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomContext: any = React.createContext({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useCustomContext(): any {
  return React.useContext(CustomContext);
}

export default CustomContext;
